<template>
  <div id="imot" :class="[layoutSizeClass, textColorClass]" ref="appContainer">
    <router-view v-if="settings.loaded && filters.loaded && vehicles.loaded" />
    <div v-else class="imot-app-loading"></div>
  </div>
</template>

<script>
import axios from 'axios'
import VehicleList from '@/models/vehicleList'
import Filters from '@/models/filters'
import { WPSettings } from '@/WPSettings'

export default {
  data () {
    return {
      settings: this.$store.state.settings,
      filters: this.$store.state.filters,
      vehicles: this.$store.state.vehicles
    }
  },
  computed: {
    layoutSizeClass: function () {
      return 'layout-' + this.$store.state.layout.size
    },
    textColorClass: function () {
      return this.$store.state.settings.general !== null
        ? '-mainTextColor-' + this.$store.state.settings.general.mainTextColor
        : ''
    }
  },
  mounted () {
    // Get settings from API
    axios.get(WPSettings.API_URL + '/get-settings').then(response => {
      this.$store.commit('settings/setFromAPI', response.data)

      // Set default view mode and sorting
      this.$store.commit(
        'vehicles/updateViewMode',
        this.$store.state.settings.general.defaultView
      )
      this.$store.commit(
        'vehicles/updateSorting',
        this.$store.state.settings.general.defaultSorting
      )
    })

    // Get filters from API
    axios
      .get(WPSettings.API_URL + '/get-filters')
      .then(response =>
        this.$store.commit('filters/setFromAPI', {
          filterData: new Filters(response.data),
          query: this.$route.query
        })
      )

    // Get vehicles from API
    axios
      .get(WPSettings.API_URL + '/get-vehicles')
      .then(response =>
        this.$store.commit(
          'vehicles/setFromAPI',
          new VehicleList(response.data)
        )
      )

    // Add event listener for layout size
    this.$nextTick(() => {
      window.addEventListener('resize', this.updateLayoutSize)
    })
  },
  created () {
    this.updateLayoutSize(true)
  },
  methods: {
    updateLayoutSize (force = false) {
      // Delay with 150ms after stop resizing
      if (!force && this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        // Define variables
        const width = this.$refs.appContainer.offsetWidth
        const breakpoints = [
          { class: 'xs', size: 0 },
          { class: 'sm', size: 540 },
          { class: 'md', size: 720 },
          { class: 'lg', size: 960 },
          { class: 'xl', size: 1300 }
        ]
        let newSize

        // Find current layout size based on breakpoints
        breakpoints.forEach(breakpoint => {
          if (width >= breakpoint.size) {
            newSize = breakpoint.class
          }
        })

        // Save size
        this.$store.commit('layout/update', newSize)
      }, 150)
    }
  },
  watch: {
    $route (to, from) {
      const appContainer = document.querySelector('#imot')
      window.scrollTo({
        top: appContainer.offsetTop,
        left: 0,
        behavior: 'auto'
      })
    }
  }
}
</script>
